// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .menu-bar {
  box-sizing: border-box;
  list-style-type: none;
  padding: 0;
  padding-right: 20px;
  position: relative;
  margin: 5px 0px;
  background-color: white;
  border: 1px solid #ddd;
  display: inline-flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: space-between;
}

.escher-container .dropdown {
  position: relative;
  float: left;
  box-sizing: border-box;
  font-size: 12px;
  border-radius: 3px;

  /* these sometimes get overridden */
  margin: 0 !important;
  font-weight: normal !important;

  text-align: center;
  vertical-align: middle;
  -ms-touch-action: none;
  touch-action: none;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.escher-container .dropdownButton {
  color: #d9230f!important;
  border: 1px solid transparent;
  padding: 6px 9px;
}

.escher-container .helpButton {
  color: #d9230f!important;
  padding: 0px 5px;
  background-color: #f5f5f5!important;
  border: 0!important;
  text-decoration: unset;
  height: fit-content;
  position: absolute;
  right: 0;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.escher-container .dropdownButton:focus, .escher-container .helpButton:focus {
  color: #91170a!important;
  text-decoration: underline;
}

.escher-container .dropdownButton:hover, .escher-container .helpButton:hover {
  color: #91170a!important;
  text-decoration: underline;
}

.escher-container .menu-bar .icon-sort-down {
  position: absolute;
  font-size: 10px;
  margin-left: -5px;
}

@media (min-width: 550px) {
  .escher-container .menu-bar {
    padding-right: 25px;
  }

  .escher-container .dropdown {
    font-size: 18px;
  }

  .escher-container .dropdownButton {
    padding: 6px 10px;
    padding-right: 16px;
  }

  .escher-container .helpButton {
    font-size: 16px;
  }

  .escher-container .menu-bar .icon-sort-down {
    font-size: 14px;
  }
}

.escher-container .menu {
  box-sizing: border-box;
  font-weight: normal!important;
  word-spacing: 0;
  position: absolute;
  white-space: nowrap;
  top: 103%;
  left: -1%;
  z-index: 1000;
  display: block;
  float: none;
  min-width: 160px;
  padding: 5px 0;
  list-style: none;
  font-size: 13px;
  box-shadow: 0 6px 12px rgba(0,0,0,0.175);
  background-clip: padding-box;
  border: 1px solid #ddd;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 0;
  margin: 0;
  text-align: left;
}

.escher-container #rightMenu {
  left: auto;
  right: -2%;
}

.escher-container .menu li:hover {
  background-color: #d9230f;
  color: #FFFFFF;
}

.escher-container .menu li, .menu label {
  font-size: 15px;
  display: block;
  color: #444444;

  /* these sometimes get overridden */
  font-weight: normal !important;
  margin: 0 !important;
}

.escher-container .menu.ul.li {
  background-color: rgba(255, 255, 255, 0.95);
}

.escher-container .menuButton {
  box-sizing: border-box;
  width: 100%;
  padding: 5px 20px;
  margin: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.escher-container label:focus, .menuButton:focus {
  background-color: #d9230f;
  color: #FFFFFF;
}

.escher-container .menuButton:hover {
  background-color: #d9230f;
  color: #FFFFFF;
}

.escher-container input[type="file"] {
  display: none;
}

.escher-container #disabled {
  color: #e0e0e0;
}

.escher-container #disabled:hover, #disabled:focus {
  background-color: rgba(255, 255, 255, 0.95);
  cursor: default;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
  vertical-align: middle;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 25px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 19px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #d9230f;
}

input:checked + .slider:before {
  transform: translateX(25px);
}

.switch-container {
  display: flex;
  align-items: center;
}

.switch-description {
  margin-right: 10px;
  font-size: 16px;
}

/* Tooltip styling */
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 125%; /* Position the tooltip below the switch */
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%; /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

`, "",{"version":3,"sources":["webpack://./src/Dropdown.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;;EAElB,mCAAmC;EACnC,oBAAoB;EACpB,8BAA8B;;EAE9B,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,4BAA4B;EAC5B,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;;EAEd,mCAAmC;EACnC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS,EAAE,0CAA0C;EACrD,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY,EAAE,8BAA8B;EAC5C,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".escher-container .menu-bar {\n  box-sizing: border-box;\n  list-style-type: none;\n  padding: 0;\n  padding-right: 20px;\n  position: relative;\n  margin: 5px 0px;\n  background-color: white;\n  border: 1px solid #ddd;\n  display: inline-flex;\n  box-sizing: border-box;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.escher-container .dropdown {\n  position: relative;\n  float: left;\n  box-sizing: border-box;\n  font-size: 12px;\n  border-radius: 3px;\n\n  /* these sometimes get overridden */\n  margin: 0 !important;\n  font-weight: normal !important;\n\n  text-align: center;\n  vertical-align: middle;\n  -ms-touch-action: none;\n  touch-action: none;\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.escher-container .dropdownButton {\n  color: #d9230f!important;\n  border: 1px solid transparent;\n  padding: 6px 9px;\n}\n\n.escher-container .helpButton {\n  color: #d9230f!important;\n  padding: 0px 5px;\n  background-color: #f5f5f5!important;\n  border: 0!important;\n  text-decoration: unset;\n  height: fit-content;\n  position: absolute;\n  right: 0;\n  font-size: 12px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.escher-container .dropdownButton:focus, .escher-container .helpButton:focus {\n  color: #91170a!important;\n  text-decoration: underline;\n}\n\n.escher-container .dropdownButton:hover, .escher-container .helpButton:hover {\n  color: #91170a!important;\n  text-decoration: underline;\n}\n\n.escher-container .menu-bar .icon-sort-down {\n  position: absolute;\n  font-size: 10px;\n  margin-left: -5px;\n}\n\n@media (min-width: 550px) {\n  .escher-container .menu-bar {\n    padding-right: 25px;\n  }\n\n  .escher-container .dropdown {\n    font-size: 18px;\n  }\n\n  .escher-container .dropdownButton {\n    padding: 6px 10px;\n    padding-right: 16px;\n  }\n\n  .escher-container .helpButton {\n    font-size: 16px;\n  }\n\n  .escher-container .menu-bar .icon-sort-down {\n    font-size: 14px;\n  }\n}\n\n.escher-container .menu {\n  box-sizing: border-box;\n  font-weight: normal!important;\n  word-spacing: 0;\n  position: absolute;\n  white-space: nowrap;\n  top: 103%;\n  left: -1%;\n  z-index: 1000;\n  display: block;\n  float: none;\n  min-width: 160px;\n  padding: 5px 0;\n  list-style: none;\n  font-size: 13px;\n  box-shadow: 0 6px 12px rgba(0,0,0,0.175);\n  background-clip: padding-box;\n  border: 1px solid #ddd;\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.escher-container #rightMenu {\n  left: auto;\n  right: -2%;\n}\n\n.escher-container .menu li:hover {\n  background-color: #d9230f;\n  color: #FFFFFF;\n}\n\n.escher-container .menu li, .menu label {\n  font-size: 15px;\n  display: block;\n  color: #444444;\n\n  /* these sometimes get overridden */\n  font-weight: normal !important;\n  margin: 0 !important;\n}\n\n.escher-container .menu.ul.li {\n  background-color: rgba(255, 255, 255, 0.95);\n}\n\n.escher-container .menuButton {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 5px 20px;\n  margin: 0;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.escher-container label:focus, .menuButton:focus {\n  background-color: #d9230f;\n  color: #FFFFFF;\n}\n\n.escher-container .menuButton:hover {\n  background-color: #d9230f;\n  color: #FFFFFF;\n}\n\n.escher-container input[type=\"file\"] {\n  display: none;\n}\n\n.escher-container #disabled {\n  color: #e0e0e0;\n}\n\n.escher-container #disabled:hover, #disabled:focus {\n  background-color: rgba(255, 255, 255, 0.95);\n  cursor: default;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 25px;\n  vertical-align: middle;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 25px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 19px;\n  width: 19px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #d9230f;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(25px);\n}\n\n.switch-container {\n  display: flex;\n  align-items: center;\n}\n\n.switch-description {\n  margin-right: 10px;\n  font-size: 16px;\n}\n\n/* Tooltip styling */\n.tooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 120px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  top: 125%; /* Position the tooltip below the switch */\n  left: 50%;\n  margin-left: -60px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.tooltip .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%; /* At the top of the tooltip */\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent black transparent;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n  opacity: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
